import { inject, Injectable } from '@angular/core';
import { ModalService } from '@epicuro-next/ataraxia/modal';
import {
  invoicesModalHeader,
  trackAndTraceModalHeader,
} from '@epicuro-next/constants/features/localization';
import { DeliveryInfo } from '@epicuro-next/models/order-book';
import { fromDynamicEvent } from '@epicuro-next/platform/dynamic-actions';
import { ComponentStore } from '@ngrx/component-store';
import { tap } from 'rxjs';

import { OrderRowLinksModalComponent } from '../../components/links-modal/links-modal.component';
import { ILinksModalPayload } from '../../models/links-modal-payload';

@Injectable()
export class ModalActionsEffectsService extends ComponentStore<object> {
  private readonly modalService = inject(ModalService);

  public triggerTrackingModal$ = this.effect<{ detail: DeliveryInfo[] }>(
    (event$) => {
      return event$.pipe(
        tap(({ detail }: { detail: DeliveryInfo[] }) => {
          const trackingLinks = detail.map((item: DeliveryInfo) => ({
            text: item.trackingNumber,
            href: item.trackingUrl,
          }));
          this.openLinksModal(trackingLinks, trackAndTraceModalHeader);
        }),
      );
    },
  )(fromDynamicEvent('[Dynamic Actions] [OrderBook] tracking-modal'));

  public triggerInvoiceModalUrls$ = this.effect<{
    detail: Record<string, string>;
  }>((trigger$) => {
    return trigger$.pipe(
      tap(({ detail }: { detail: Record<string, string> }) => {
        const invoiceLinks = Object.keys(detail).map((key) => ({
          text: key,
          href: detail[key],
        }));
        this.openLinksModal(invoiceLinks, invoicesModalHeader);
      }),
    );
  })(fromDynamicEvent('[Dynamic Actions] [OrderBook] invoices-modal'));

  private openLinksModal(links: ILinksModalPayload[], title: string) {
    const ref = this.modalService.open(OrderRowLinksModalComponent, {
      attachBrowserHistory: false,
      size: 'sm',
    });

    ref.componentInstance.links = links;
    ref.componentInstance.title = title;
  }
}
